export default __webpack_public_path__ + "static/media/loading.7c6c4674.svg";